import React, { FC } from 'react'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import { IKnockStatusIcon } from '@user/store/knockStatus/typings'
import { KnockStatusIcon } from '@user/components/KnockStatus'

interface PreviewKnockStatusProps {
  name: string
  color: string | null
  icon: IKnockStatusIcon | null
}

export const PreviewKnockStatus: FC<PreviewKnockStatusProps> = ({
  color,
  icon,
}) => {
  return (
    <Box>
      <Typography variant="subtitle3">Preview</Typography>
      <Box
        sx={{
          mt: 1,
          width: '100%',
          height: '161px',
          backgroundColor: '#EAEEF2',
          borderRadius: '8px',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          p: 2,
        }}
      >
        <Box
          sx={{
            width: 160,
            height: 160,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <KnockStatusIcon
            color={color || '#F3F5F7'}
            icon={icon ?? null}
            width={160}
            height={160}
            viewBox={'0 0 50 50'}
            isPreview
          />
        </Box>
      </Box>
    </Box>
  )
}
